export default function () {
    if ($("header .corner").hasClass("open")) {
        $("header .corner").attr("aria-hidden", "false"); //	$("header .corner a").attr("tabindex", "0");
      } else {
        $("header .corner").attr("aria-hidden", "true"); //	$("header .corner a ").attr("tabindex", "-1");
      }
}